import { CURRENCY } from '../constants';
import { convertNumberToLocaleMoneyFormat } from './convert-number-to-locale-money-format';
export var calculateAndConvertLoanToMoney = function (money, loanRepaymentPrice, currency) {
    if (currency === void 0) { currency = CURRENCY; }
    var loanRepaymentPricePercent = loanRepaymentPrice / 100;
    var amountFull = money + money * loanRepaymentPricePercent;
    var costIncluded = money * loanRepaymentPricePercent;
    var convertedAmountFull = "".concat(convertNumberToLocaleMoneyFormat(amountFull), " ").concat(currency);
    var convertedCostIncluded = "".concat(convertNumberToLocaleMoneyFormat(Number(costIncluded)), " ").concat(currency);
    return {
        convertedAmountFull: convertedAmountFull,
        convertedCostIncluded: convertedCostIncluded,
        costIncluded: costIncluded,
        amountFull: amountFull,
    };
};
